var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-form-group',{attrs:{"name":_vm.fieldName,"inputType":"suggestion[]","label":"Вид деятельности","model":_vm.fields,"options":_vm.options,"tabView":_vm.tabView,"formGroupStyle":_vm.formGroupStyle,"required":_vm.required}})}
var staticRenderFns = []

export { render, staticRenderFns }